import Namespace from "./Namespace.js";

export function requireNamespace(root: any, namespace: string | Array<string>): any {
	if (typeof root === "object") {
		if (typeof namespace === "string") {
			let path = namespace.split(".");

			return requireNamespace(root, path);
		} else if (Array.isArray(namespace)) {
			let current: any = root;
			for (let i = 0; i < namespace.length; i++) {
				current = current[namespace[i]] = current[namespace[i]] || new (Namespace as any)();
			}

			return current;
		}
	}
}
